module.exports = __webpack_public_path__ + "img/img_applicable.1489a49b.png";